


































































































































































































import Vue from "vue";
import * as R from "ramda";
import { format } from "date-fns";
import PerspectiveDialog from "@/components/projects/PerspectiveDialog.vue";

import PROJECT from "@/graphql/projects/Project.gql";
import PROJECT_CREATE from "@/graphql/projects/ProjectCreate.gql";
import PROJECT_UPDATE from "@/graphql/projects/ProjectUpdate.gql";
import PROJECTS from "@/graphql/projects/Projects.gql";
import USER from "@/graphql/users/User.gql";
import GIS_WEB_UPDATE from "@/graphql/projects/GisWebUpdate.gql";
import BIM_VIEWER_UPDATE from "@/graphql/projects/BimViewerUpdate.gql";
import DAMAGE_TABLE_UPDATE from "@/graphql/projects/DamageTableUpdate.gql";
import HDR_VIEWER_UPDATE from "@/graphql/projects/HdrViewerUpdate.gql";
import VIEWER_3D_UPDATE from "@/graphql/projects/Viewer3dUpdate.gql";

import { ApolloQueryResult } from "apollo-client";
import {
  Project,
  Project_project,
  updateProjectInput,
  ProjectCreate,
  ProjectUpdate
} from "@/api-types";
import { DocumentNode } from "graphql";
import { FetchResult } from "apollo-link";

export default Vue.extend({
  name: "ProjectDialog",
  components: { PerspectiveDialog },
  props: {
    editProject: String
  },
  data: function() {
    return {
      form: {
        name: "",
        description: "",
        startimage: "",
        thumbnail: "",
        testReport: null,
        damageTable: { active: false },
        hdrViewer: { active: false },
        bimViewer: { active: false, path: null },
        viewer3d: { active: false },
        gisWeb: { active: false }
      },
      tools: [
        {
          key: "viewer3d",
          name: "3D Viewer"
        },
        {
          key: "hdrViewer",
          name: "HDR Viewer"
        },
        {
          key: "damageTable",
          name: "Live Viewer"
        },
        {
          key: "bimViewer",
          name: "BIM Viewer"
        },
        {
          key: "gisWeb",
          name: "Web GIS"
        }
      ],
      project: null as Project_project | null,
      userIds: [] as string[],
      loading: "initial",
      viewer3d: "",
      hdrViewer: "",
      gisWeb: "",
      files: {
        testReport: null,
        thumbnail: null
      } as { [key: string]: File | null },
      nameRules: [
        (v: string) => !!v || "Bitte eine Projektbezeichnung eingeben"
      ],
      pdfRules: [
        (file: File) =>
          Boolean(file) ||
          file.size < 10000000 ||
          "Die Datei muss kleiner als 10MB sein",
        (file: File) =>
          Boolean(file) ||
          file.type === "application/pdf" ||
          "Die Datei muss eine PDF sein"
      ],
      imageRules: [
        (file: File) =>
          Boolean(file) ||
          file.size < 5000000 ||
          "Die Datei muss kleiner als 5MB sein",
        (file: File) =>
          Boolean(file) ||
          file.type === "image/png" ||
          "Das Dateiformat muss eine PNG sein"
      ],
      descriptionRules: [
        (v: string) => !!v || "Bitte eine Projektbeschreibung eingeben"
      ]
    };
  },
  apollo: {
    project: {
      query: PROJECT,
      variables() {
        return { id: this.editProject };
      },
      result({ data }: ApolloQueryResult<any>) {
        this.form = R.mapObjIndexed(
          (__, k) => data.project[k],
          this.form
        ) as any;
        this.loading = "";
      },
      skip() {
        this.loading = "";
        return !this.editProject || this.editProject === "new";
      }
    },
    projects: {
      query: PROJECTS
    }
  },
  methods: {
    async save(after: string = "") {
      if (!(this.$refs.form as any).validate()) return;

      this.loading = "save";
      const formData = new FormData();
      for (const prop in this.files) {
        let file = this.files[prop];
        if (file) {
          if (file!.type === "image/png") {
            const name = `${format(new Date(), "YYYYMMDDHHmmss")}-${
              file!.name
            }`;
            file = new File([file!], name, { type: file!.type });
          }
          formData.append(prop, file);
          (this.form as any)[prop] = file.name;
        }
      }
      await this.axios.post("upload_project_files", formData);

      let input: any = {
        ...R.omit(
          ["damageTable", "hdrViewer", "bimViewer", "viewer3d", "gisWeb"],
          this.form
        )
      };

      let mutation: DocumentNode;
      if (this.editProject === "new") {
        mutation = PROJECT_CREATE;
        input = { ...input, routeName: this.formatName(this.form.name) };
      } else {
        mutation = PROJECT_UPDATE;
        input = { ...input, id: this.project!.id };
      }

      const fetchResult: FetchResult<any> = await this.$apollo.mutate({
        mutation,
        variables: {
          input
        }
      });

      let project: any;
      if (this.editProject === "new") {
        project = fetchResult.data.createProject.project;
      } else {
        project = fetchResult.data.updateProject.project;
      }

      const tools = [
        {
          mutation: DAMAGE_TABLE_UPDATE,
          name: "damageTable"
        },
        {
          mutation: HDR_VIEWER_UPDATE,
          name: "hdrViewer"
        },
        {
          mutation: BIM_VIEWER_UPDATE,
          name: "bimViewer"
        },
        {
          mutation: VIEWER_3D_UPDATE,
          name: "viewer3d"
        },
        {
          mutation: GIS_WEB_UPDATE,
          name: "gisWeb"
        }
      ];
      for (const tool of tools) {
        const formProp = (this.form as any)[tool.name];
        const input = {
          id: project![tool.name]!.id,
          active: formProp.active
        } as any;
        if (formProp.path) input.path = formProp.path;
        await this.$apollo.mutate({
          mutation: tool.mutation,
          variables: {
            input
          }
        });
      }
      await this.$apollo.queries.project.refetch();
      await this.$apollo.queries.projects.refetch();

      this.loading = "";
      if (after === "close") {
        this.$emit("close");
      } else {
        this.$emit("update", project.id);
        return project;
      }
    },
    async editPerspectives(tool: string) {
      const project = await this.save();
      if (tool === "hdrViewer") {
        this.hdrViewer = project.hdrViewer.id;
      } else if (tool === "viewer3d") {
        this.viewer3d = project.viewer3d.id;
      } else if (tool === "gisWeb") {
        this.gisWeb = project.gisWeb.id;
      }
    },
    formatName(name: string) {
      return name
        .toLowerCase()
        .replace(/ü/g, "ue")
        .replace(/ö/g, "oe")
        .replace(/ä/g, "ae")
        .replace(/ /g, "-");
    }
  }
});
